import React from 'react';
import { Button } from '@/components/ui/button';
import { Square, Circle, Minus } from 'lucide-react';

const BG_COLORS = ['#FFFFFF', '#111111', '#3A7BFF', '#FF6B9D', '#22C55E', '#F59E0B', '#A855F7'];

/**
 * "Elements" category — shapes and page background, same reuse pattern
 * as the Main Editor's Effects/Transitions catalog panels: real, working
 * additions to the active page (no new rendering engine).
 */
export function DesignElementsPalette({ onAddShape, background, onBackgroundChange, disabled }) {
  if (disabled) {
    return <p className="text-sm text-[#8A93A6] text-center py-6" data-testid="design-elements-empty">Create or select a design first.</p>;
  }
  return (
    <div className="space-y-4" data-testid="design-elements-panel">
      <div>
        <p className="text-[11px] uppercase tracking-wide text-[#555E6E] mb-1.5">Shapes</p>
        <div className="grid grid-cols-3 gap-1.5">
          <Button size="sm" variant="outline" className="border-white/10 flex-col h-14 gap-1" onClick={() => onAddShape('rectangle')} data-testid="design-add-shape-rectangle"><Square className="h-4 w-4" /><span className="text-[10px]">Rectangle</span></Button>
          <Button size="sm" variant="outline" className="border-white/10 flex-col h-14 gap-1" onClick={() => onAddShape('circle')} data-testid="design-add-shape-circle"><Circle className="h-4 w-4" /><span className="text-[10px]">Circle</span></Button>
          <Button size="sm" variant="outline" className="border-white/10 flex-col h-14 gap-1" onClick={() => onAddShape('line')} data-testid="design-add-shape-line"><Minus className="h-4 w-4" /><span className="text-[10px]">Line</span></Button>
        </div>
      </div>
      <div>
        <p className="text-[11px] uppercase tracking-wide text-[#555E6E] mb-1.5">Page Background</p>
        <div className="flex items-center gap-1.5 flex-wrap">
          {BG_COLORS.map((c) => (
            <button key={c} onClick={() => onBackgroundChange(c)} className={`h-7 w-7 rounded-full border-2 ${background === c ? 'border-[#3A7BFF]' : 'border-white/20'}`} style={{ background: c }} data-testid={`design-bg-color-${c.replace('#', '')}`} />
          ))}
        </div>
      </div>
    </div>
  );
}
